import { all, takeEvery, put, call, select } from 'redux-saga/effects';
import actions from './actions';
import { tableConfig } from '../../../settings/index';
import Api, { executeAction } from '../../../helpers/api';
import { sendRequest } from '../../../helpers/saga';
import { logger } from '../../../helpers/logger';
import { t } from '../../../i18n';
import notifications from '../../../redux/notifications/actions';

const api = new Api('dashboard/worker_infractions/exceptions');

function* loadData({ payload }) {
  try {
    const { page = 1, pageSize = tableConfig.pageSize, filter, ...restPayload } = payload;
    const search = { ...restPayload, page, pageSize, filter };
    const currentOrganizationId = yield select(state => state.StartAppSettings?.organization?.id);

    const { result } = yield all({
      result: call(sendRequest, api.load, { search }, notifications.REQUEST_ERROR),
    });

    if (result?.data?.success?.data) {
      const { records, totalCount, filteredCount, sortableColumns, filters } = result.data.success.data;

      yield put(
        actions.loadDataSuccess({
          data: records.map(item => {
            if (!item.actions) {
              item.actions = [];
            }

            const workerOrgId = item.worker?.organization?.id;

            if (!workerOrgId || workerOrgId === currentOrganizationId) {
              item.actions.unshift({ key: 'go_to_talents_details' });
            }

            item.actions.unshift({ key: 'go_to_job_details' });

            return item;
          }),
          total: totalCount,
          filteredTotal: filteredCount,
          sortableColumns,
          filters,
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

function* processAction({ payload }) {
  try {
    const { method, url, key, cb } = payload;
    const data = {};

    const result = yield call(sendRequest, executeAction, { url, method, data }, notifications.REQUEST_ERROR);

    if (result && result.data) {
      if (cb) {
        cb();
      }
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t(
            `dash.common.notification.${key === 'accept' ? 'accepted_successfully' : 'declined_successfully'}`,
            {
              item: t('dash.landingPage.infractionsExceptions.exception_label'),
            },
          ),
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD_REQUEST, loadData), takeEvery(actions.PROCESS_ACTION, processAction)]);
}
